import { Component, EventEmitter, Input, Output } from "@angular/core";

import { combineLatest, filter, map, Observable } from "rxjs";

import { Shop } from "@hermes/api-model-shop";
import {
    DEFAULT_SECTIONS_TO_DISPLAY,
    DirectionLinkMode,
    SectionName,
    ShopInfoEvent,
    StorePageLinkMode,
} from "@hermes/fragments/shop";
import {
    HoveredShop,
    isDefinedHoveredShop,
    ShopLocatorFacade,
    ShopsStateData,
} from "@hermes/states/shop-locator";

interface ShopStream {
    hovered: HoveredShop;
    shops: ShopsStateData;
    shop: Shop;
    shopId: string;
    directionLinkMode: DirectionLinkMode;
    directionUrl: string;
    meters: number;
}

@Component({
    selector: "h-shop-locator-map-item",
    templateUrl: "./shop-locator-map-item.component.html",
    styleUrls: ["./shop-locator-map-item.component.scss"],
    standalone: false,
})
export class ShopLocatorMapItemComponent {
    @Input()
    public sectionsToDisplay: Set<SectionName> = DEFAULT_SECTIONS_TO_DISPLAY;

    public isHovered$ = this.shopLocatorFacade.hoveredShop$.pipe(
        map(isDefinedHoveredShop),
    );

    public shopStream$: Observable<ShopStream> = combineLatest([
        this.shopLocatorFacade.hoveredShop$.pipe(filter(isDefinedHoveredShop)),
        this.shopLocatorFacade.shops$,
        this.shopLocatorFacade.extraInfos$,
    ]).pipe(
        map(
            ([hovered, shops, extraInfo]): ShopStream => ({
                hovered,
                shops,
                shop: shops[hovered.shopId],
                shopId: hovered.shopId,
                directionLinkMode: extraInfo[hovered.shopId]?.directionUrl
                    ? "icon"
                    : "none",
                directionUrl: extraInfo?.[hovered?.shopId]?.directionUrl,
                meters: extraInfo?.[hovered?.shopId]?.meters,
            }),
        ),
    );

    @Output()
    public shopInfoEvents = new EventEmitter<{
        event: ShopInfoEvent;
        shop: Shop;
        shopIndex: number;
    }>();

    @Input() public linkMode: StorePageLinkMode = "none";

    constructor(public shopLocatorFacade: ShopLocatorFacade) {}
}
